"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxxessHospice = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class AxxessHospice {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        var _a, _b;
        pastedData = pastedData.replace(/\r\n/g, "\n");
        pastedData = pastedData.replace("Payer information\n", "Payer Information\n");
        pastedData = pastedData.replace(/, Ml /g, ", MI ");
        try {
            const patientInfoRaw = (0, helper_1.substrInBetweenInclusive)(pastedData, "Demographics\n", "Payer Information\n");
            const patientInfo = this.gettingPatientDetails(patientInfoRaw);
            const insurance = this.getInsurance(pastedData);
            const contactDetails = this.getContactDetails(pastedData);
            const mrn = (_b = (_a = pastedData.match(/MRN:\s*([A-Za-z0-9]+)/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.trim();
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), contactDetails), (mrn && { mrn }));
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const name = (0, helper_1.substrInBetweenNew)(sessionFirst, "Demographics", "DOB:");
        let Dob = (0, helper_1.substrInBetweenNew)(sessionFirst, "DOB:\n", "Sex:\n");
        if (!Dob) {
            Dob = (0, helper_1.substrInBetweenNew)(sessionFirst, "DOB:\n", "Gender:\n");
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(name)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        let insurance = (0, helper_1.substrInBetweenNew)(sessionThird, "Primary Payer:", "Secondary\nPayer:");
        insurance = insurance.split("\nMember ID:")[0];
        insurance = insurance.trim().replace(/\n/g, " ");
        return {
            insurance,
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(pastedData) {
        const caregiverRaw = (0, helper_1.substrInBetweenNew)(pastedData, "Authorized Contacts\n", "Face Sheet Comments\n");
        const physiciansRaw = (0, helper_1.substrInBetweenNew)(pastedData, "Attending Physician:\n", "Hospice Physician:\n");
        const pharmacyRaw = (0, helper_1.substrInBetweenInclusive)(pastedData, "Pharmacy\n", "Advance Directives\n");
        const contacts = {
            info: {
                physician: this.getPhysician(physiciansRaw),
                pharmacy: this.getPharmacy(pharmacyRaw),
                careGiver: this.getCaregiver(caregiverRaw),
            },
        };
        //@Return
        return contacts;
    }
    getPhysician(data) {
        var _a, _b, _c;
        const physicians = [];
        const physicianNameRaw = (_a = data.match(/[A-Z]+, [A-Z]+/)) === null || _a === void 0 ? void 0 : _a[0];
        const physicianNameParts = physicianNameRaw === null || physicianNameRaw === void 0 ? void 0 : physicianNameRaw.split(",");
        const name = `${(_b = physicianNameParts === null || physicianNameParts === void 0 ? void 0 : physicianNameParts[1]) !== null && _b !== void 0 ? _b : ""} ${(_c = physicianNameParts === null || physicianNameParts === void 0 ? void 0 : physicianNameParts[0]) !== null && _c !== void 0 ? _c : ""}`.trim();
        const numbersRaw = (0, helper_1.substrInBetweenNew)(data, "Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(numbersRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            physicians.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const name = (0, helper_1.substrInBetweenNew)(data, "Name:", "\nAddress:").trim();
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        const caregivers = [];
        const firstContactRaw = (0, helper_1.substrInBetweenInclusive)(data, "First Contact:\n", "Role:\n");
        const secondContactRaw = (0, helper_1.substrInBetweenInclusive)(data, "Second Contact:\n", "Role:\n");
        if (firstContactRaw) {
            caregivers.push(this.parseCaregiver(firstContactRaw, 1));
        }
        if (secondContactRaw) {
            caregivers.push(this.parseCaregiver(secondContactRaw, 2));
        }
        return caregivers.filter(c => c !== undefined);
    }
    parseCaregiver(data, sortOrder) {
        const nameMatch = data.match(/\n[A-Z]+, [A-Z]+.*\n/g);
        const phoneMatch = data.match(/\(\d\d\d\) \d\d\d\s?[\-\*]\d\d\d\d/);
        if (nameMatch && phoneMatch) {
            const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneMatch[0])
                .replace(/\s/, "")
                .replace(/[\s\-\*()]/g, ""));
            const name = `${nameMatch[0].split(",")[1].trim()} ${nameMatch[0]
                .split(",")[0]
                .trim()}`;
            return {
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder,
            };
        }
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const numbers = firstSession.match(/\(\d\d\d\) \d\d\d\-\d\d\d\d\n/);
        if (numbers && numbers.length) {
            const number = (0, helper_1.trim)(numbers[0].replace(/[\s-()]/g, ""));
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        const addressString = (0, helper_1.substrInBetweenNew)(firstSession, "Primary Address:", "Mailing Address:");
        info.address.placeName = (0, helper_1.trim)(addressString);
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const nameMatch = sessionFirst.match(/([A-Z]{2,}),\s+([A-Z]+)/);
        if (nameMatch) {
            name.lastName = nameMatch[1].trim();
            name.firstName = nameMatch[2].trim();
        }
        return name;
    }
}
exports.AxxessHospice = AxxessHospice;
